import useMe from "./useMe";
import roles from "../consts/roles";

const useEnabledPendingStatus = () => {
    const {role} = useMe();
    return role !== roles.INVESTIGATOR;
};

export default useEnabledPendingStatus;